import $ from 'jquery';
var HowNeonWorks = function(){
	var $section = $('#HowNeonWorks');
	if( $section.length < 1) return false;
	var	$gasses = $section.find('.js-gas'),
			$body = $section.find('.js-body'),
			activeClass = 'is-active',
			questionBodyTemplate = $('#HowNeonWorksQuestionTemplate').html(),
			gasBodyTemplate = $('#HowNeonWorksGasTemplate').html();

			console.log('questionBodyTemplate');
			console.log(questionBodyTemplate);
			console.log('gasBodyTemplate');
			console.log(gasBodyTemplate);

	// Set up Template
	// $colorTemplate.remove();
	// colorTemplateString = colorTemplateString.replace(colorTemplateSelector, '');

	// Event Listeners
	$gasses.on('click', gasClickHandler);

	// Initial State
	activateGas( $( $gasses.eq(1) ) );

	function gasClickHandler(event) {
		event.preventDefault();
		activateGas($(this));
	}

	function activateGas( $gas ) {
		var title = $gas.data('title'),
				primaryColor = $gas.data('primary-color'),
				$template;

		// Set proper template & apply transforms
		if( $gas.hasClass('is-question') ) {
			$template = $( $.parseHTML(questionBodyTemplate) );
		} else {
			$template = $( $.parseHTML(gasBodyTemplate) );
			console.log($template);
			$template.find('.js-gas-name').text(title);
			$template.find('.js-color-primary').css({ 'background-color': primaryColor });
		}

		console.log($template);

		// Tweak Classes
		$gasses.removeClass(activeClass);
		$gas.addClass(activeClass);

		// Apply Template
		$body.html( $template );
	}

	// function updateBodyInfo( params ) {
	// 	var additionalColorElements = [];
	// 	// Title
	// 	$gasName.text(params.title);
	// 	$colorPrimary.css({ 'background-color': params.primaryColor });

	// 	// $.each(params.additionalColors, function(index, color){
	// 	// 	additionalColorElements.push( $(colorTemplateString).css({ 'background-color': color }) );
	// 	// });

	// 	// $colorList.html( additionalColorElements );
	// }

};

export default HowNeonWorks();